module.exports = __webpack_public_path__ + "static/profile_pic-9fbab6ab17c36c7cac8043ebc918fe87.png";